import { selector, useRecoilValue } from 'recoil';
import { connectorViewerOpenPhaseState } from '~/state/atoms/dicomProcessorAtoms';

// A selector, not an inline derivation: one open steps the phase atom five
// times, but subscribers only need to render when the boolean flips.
const isOpeningInViewerState = selector<boolean>({
    key: 'isOpeningInViewer',
    get: ({ get }) => get(connectorViewerOpenPhaseState) !== 'idle',
});

/**
 * True while an open is in flight; screens disable their own Open controls
 * so a second request is refused visibly. Subscribes, unlike
 * `useRefuseWhileViewerOpening`, because it drives rendering.
 */
export function useIsOpeningInViewer(): boolean {
    return useRecoilValue(isOpeningInViewerState);
}
